import React, { useEffect } from 'react';
import styles from './Dashboard.module.scss'
import DateRangeSelector from 'components/miscellaneous/DateRangeSelector/DateRangeSelector';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getUserClinic } from "store/auth-slice";
import StatisticsWidget from 'components/clinic/Dashboard/StatisticsWidget/StatisticsWidget';
import PlatformsUsageWidget from "components/clinic/Dashboard/PlatformsUsageWidget/PlatformsUsageWidget";
import DashboardBox from "components/miscellaneous/DashboardBox/DashboardBox";
import { $t } from 'helpers/translator';
import { default as TreatmentsTimeGraph } from 'components/clinic/Dashboard/TreatmentsGraph/TreatmentsGraph';
import TreatmentsGraph from 'components/Admin/Dashboard/TreatmentsGraph/TreatmentsGraph';
import ApplicatorsWidget from 'components/clinic/Dashboard/ApplicatorsWidget/ApplicatorsWidget';
import AvgAreaSessionsWidget from 'components/clinic/Dashboard/AvgAreaSessionsWidget/AvgAreaSessionsWidget';
import TopStaffWidget from 'components/clinic/Dashboard/TopStaffWidget/TopStaffWidget'
import PlatformAdded from "../../../components/clinic/PlatformAdded/PlatformAdded";
import MultiSelect from '../../../components/miscellaneous/MultiSelect/MultiSelect';

const ClinicDashboard = () => {
    const dispatch = useDispatch();
    const [ dateRange, setDateRange ] = React.useState({
        startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
    });
    const [ selectedNarrowDown, setSelectedNarrowDown ] = React.useState(null);
    const [ clinic, setClinic ] = React.useState(null);

    useEffect(() => {
        dispatch(getUserClinic()).then((res) => {
            setClinic(res)
        })
    }, [])

    return (
        <div className={ styles.dashboardContainer }>
            <PlatformAdded />

            <div className={ styles.container }>
                <div className={ `d-flex justify-content-between ${styles.header}` }>
                    <h1 className={ styles.title }>Welcome Back, { clinic !== null && clinic.name }</h1>
                    <DateRangeSelector onChange={ (data) => {
                        setDateRange(data);
                    } } />
                </div>

                <div className={ styles[ 'row' ] }>
                    <StatisticsWidget dateRange={ dateRange } />
                </div>

                <div className={ styles[ 'row' ] }>
                    <div className={ `${styles[ 'component-block' ]} ${styles[ 'col8' ]}` }>
                        <div className={ styles.widget }>
                            <DashboardBox style={ { height: '100%' } } info={ "Showing the 10 most popular treatment areas" } header={ "Treatments by Area" } sideComponent={ <>
                                <MultiSelect options={ [
                                    { label: 'Patient Gender', value: 'gender' },
                                    { label: 'Patient Age', value: 'age' }
                                ] }
                                    clearable={ true }
                                    selected={ selectedNarrowDown }
                                    placeholder={ "Filter by" }
                                    onValueChange={ (data) => {
                                        const isEmpty = data?.value === undefined;
                                        setSelectedNarrowDown(isEmpty ? null : data);
                                    } } />
                            </> }>
                                <TreatmentsGraph dateRange={ dateRange } narrowDownBy={ selectedNarrowDown?.value } />
                            </DashboardBox>
                        </div>
                    </div>
                    <div className={ `${styles[ 'component-block' ]} ${styles[ 'col4' ]}` }>
                        <div className={ styles.widget }>
                            <DashboardBox info={ $t('global.chainDashboard.myClinicsInfo') }
                                header={ "Clinic Treatments" }
                            >
                                <TreatmentsTimeGraph dateRange={ dateRange } />
                            </DashboardBox>
                        </div>
                    </div>
                </div>

                <div className={ styles[ 'row' ] } style={ { paddingTop: 0 } }>
                    <div className={ `${styles[ 'component-block' ]} ${styles[ 'col4' ]}` } style={ { margin: 0 } }>
                        <div className={ styles.widget } style={ { margin: 0, height: '100%' } }>
                            <DashboardBox contentStyle={ {
                                display: 'flex',
                                flexDirection: 'column'
                            } } info={ $t('global.chainDashboard.myClinicsInfo') }
                                header={ "My Platforms" }>
                                <PlatformsUsageWidget dateRange={ dateRange } />
                            </DashboardBox>
                        </div>
                    </div>
                    <div className={ `${styles[ 'component-block' ]} ${styles[ 'col4' ]}` } style={ { margin: 0 } }>
                        <div className={ styles.widget }>
                            <DashboardBox info={ $t('global.chainDashboard.myClinicsInfo') }
                                header={ "My Applicators" }>
                                <ApplicatorsWidget />
                            </DashboardBox>
                        </div>
                        <div className={ styles.widget } style={ { marginTop: 20, marginBottom: 0 } }>
                            <DashboardBox contentStyle={ {
                                padding: 0
                            } } info={ $t('global.chainDashboard.topStaffMembersInfo') }
                                header={ $t('global.chainDashboard.topStaffMembers') }>
                                <TopStaffWidget dateRange={ dateRange } containerHeight={ 135 } />
                            </DashboardBox>
                        </div>
                    </div>
                    <div className={ `${styles[ 'component-block' ]} ${styles[ 'col4' ]}` } style={ { margin: 0 } }>
                        <div className={ styles.widget } style={ { margin: 0, height: '100%' } }>
                            <DashboardBox contentStyle={ {
                                display: 'flex'
                            } } info={ $t('global.chainDashboard.myClinicsInfo') }
                                header={ "Avg. Treatments per area" }>
                                <AvgAreaSessionsWidget dateRange={ dateRange } />
                            </DashboardBox>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default ClinicDashboard;